import React from 'react';
import icon from '@/assets/images/logo-改@2x.png';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import qrcode from "@/assets/images/download/ios.png"
import { useNavigate } from 'react-router-dom';
interface FooterProps {}
const Footer: React.FC<FooterProps> = () => {
  //国际化语言切换
    const { t } = useTranslation();
    const navigate = useNavigate();
  return (
    <footer className={styles['footer-counter']}>
      <div className={styles.container}>
        <div className={styles.row}> 
          <div className={styles.left}> 
            <img src={icon} alt="townloop" className={styles.logo} />
            <div className={styles.tagline}>
              <p>{t('footer.slogan1')}</p>
              <p>{t('footer.slogan2')}</p>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.col}>
              <div className={styles.colTitle}>{t('footer.coltitle1')}</div>
              <ul>
                <li>{t('footer.tag1')}</li>
                <li>{t('footer.tag2')}</li>
                <li>{t('footer.tag3')}</li>
                <li>{t('footer.tag4')}</li>
              </ul>
            </div>
            <div className={styles.col}>
              <div className={styles.colTitle}>{t('footer.coltitle2')}</div>
              <ul>
                <li>{t('footer.tag5')}</li>
               
              </ul>
            </div>
            <div className={styles.col}>
              <div className={styles.colTitle}>{t('footer.coltitle3')}</div>
              <ul>
                <li>{t('footer.tag6')}</li>
                <li>{t('footer.tag7')}</li>
                <li onClick={()=>{navigate(`/privacy_data`)}} style={{cursor:'pointer'}}>{t('footer.tag8')}</li>
                <li onClick={()=>{navigate('/privacyPolicy')}} style={{cursor:'pointer'}}>{t('login.PrivacyPolicy')}</li>
              </ul>
            </div>
          </div>
          <div className={styles.qrcode}>
            <img src={qrcode} alt="" />
            <div className={styles.text} onClick={()=>{navigate('/download')}}>{t('footer.Clicktoviewthedownloadguide')}</div>
            <div className={styles.text1}>({t('footer.NoteMoredownloadversionsareavailable')})</div>
          </div>
        </div>
        {/* <div className={styles.divider}></div> */}
        <div className={styles.copy}>{t('footer.copyright')}</div>
      </div>
    </footer>
  );
};

export default Footer;